import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Tab,
  Tabs,
  Slider,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
// import { BarChart, LineChart } from '@mui/x-charts';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setShowTable, setShowTrendLine } from 'src/slices/filterSlice';
import {
  selectSelectedFilter,
  selectShowTable,
  selectShowTrendLine,
} from 'src/app/selectors/filterSelectors';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { generateRandomColor } from 'src/utils/Utils';
import { MenuConfig } from 'src/types/generic';
import FunnelView from 'src/pages/FunnelView/FunnelView';

interface TileGraphProps {
  graphData: { x: number; y: number; value: number }[];
  width?: number;
  height?: number;
  config: MenuConfig
}

export const TileGraph: React.FC<TileGraphProps> = ({ graphData, config }) => {
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme
  const { channel, store, machine_type } = useSelector(selectSelectedFilter);
  const isBar = config.graphType === 'bar';

  const isShowTrendLine = useSelector(selectShowTrendLine);
  const primaryColor = theme.palette.primary.main; // Get primary color
  const selectedStores = store && store.length > 0 ? store?.split(',') : [];
  const seelctedMachineTypes = machine_type && machine_type.length > 0 ?  machine_type?.split(',') : []
  const selectedChannels =
    channel && channel.length > 0 ? store?.split(',') : [];
  let graphMultiDataKeys = selectedChannels;
  if (seelctedMachineTypes.length >= 1) {
    graphMultiDataKeys = seelctedMachineTypes;
  }
  if (selectedStores.length >= 1) {
    graphMultiDataKeys = selectedStores;
  }
  let data = []
  if(config.graphType === 'funnel'){
    data = graphData
  }else{
    data = graphData[0].data.map((item, index) => ({
      x: config.value(item.x),
      y: item.y | item.value | item.Sessions,
      value: item.value | item.Transactions,
      ...item,
      y_mavg: isShowTrendLine ? graphData[1]?.mavgData[index]?.y_mavg : 0,
    }));
    if (data && data.length > 0 && data[0].value) {
      data = data
        .filter((item) => item.y > 0 && item.value)
        .sort((a, b) => b.y - a.y);
    }
    
  }
  if (!data || data.length === 0) return <p>No data available</p>;

  return (
    <>
    {config.graphType === 'funnel' ? <FunnelView data = {data} isTile={true} />
    : <ResponsiveContainer height={70}>
      {data[0].value ? (
        <BarChart
          data={data}
          margin={{ top: 0, right: 10, left: 10, bottom: 0 }}
        >
          {/* <XAxis dataKey={(item) => config.value(item.x)} /> */}
          <Bar dataKey="y" stackId="a" fill={primaryColor} />
          {/* <Bar dataKey="value" stackId="a" fill={generateRandomColor()} /> */}
          {(config.title_key === "Time of Day" || config.title_key === "Time of Week") ? (
            //  <Bar dataKey="value" stackId="a" fill={generateRandomColor()} />
            <Bar dataKey="value" stackId="a" fill="rgb(255, 186, 0)" />
            ) : null}
            
        </BarChart>
      ) : (
        <LineChart data={data} margin={{ bottom: 0 }}>
          <XAxis stroke="#ededed" strokeWidth={2} tick={false} tickSize={0} />
          <Line
            type="linear"
            dataKey="y"
            stroke={primaryColor}
            dot={false}
            strokeWidth={1}
            isAnimationActive={false}
          />
          {graphMultiDataKeys.length > 0 ? (
            graphMultiDataKeys.map((item, index) => (
              <Line
                key={index}
                type="linear"
                dataKey={item}
                stroke={index == 0 ? primaryColor : generateRandomColor()}
                dot={false}
              />
            ))
          ) : (
            <Line
              type="linear"
              dataKey="y"
              stroke={primaryColor}
              dot={false}
              strokeWidth={1}
            />
          )}

          {isShowTrendLine && (
            <Line
              type="linear"
              dataKey="y_mavg"
              stroke="red"
              dot={false}
              strokeWidth={1}
              isAnimationActive={false}
              name="Trendline"
            />
          )}
        </LineChart>
      )}
      
    </ResponsiveContainer>
    }</>
  );
};
